import { api } from "./axios.config";
import axios from "./axios";
import { getCurrentEventId } from "../Utils/helpers";

const API_URL = api.apiUrl;
const BASE_PATH = "/event/";

export const addComment = (exhibitorId, taskId, payload) => {
    const eventId = getCurrentEventId();
    const url = `${API_URL}${BASE_PATH}${eventId}/exhibitors/${exhibitorId}/tasks/${taskId}/comments`;
    return axios.post(url, payload);
};

export const getComments = (exhibitorId, taskId, limit = 30, offset = 0) => {
    const eventId = getCurrentEventId();
    const url = `${API_URL}${BASE_PATH}${eventId}/exhibitors/${exhibitorId}/tasks/${taskId}/comments?limit=${limit}&offset=${offset}`;
    return axios.get(url);
};